export { default as SimpleIconPage } from './simple-icon-page';
